if (document.querySelector("[data-how-we-are-different-section]")) {
  // DOM elements
  var howWeAreDifferentSection = document.querySelector("[data-how-we-are-different-section]");
  var howWeAreDifferentBgElement = howWeAreDifferentSection.querySelector("[data-hwad-bg]");
  var howWeAreDifferentDrawnDifferencesElement = howWeAreDifferentSection.querySelector("[data-hwad-drawn-differences]");
  var howWeAreDifferentWrittenDifferencesElement = howWeAreDifferentSection.querySelector("[data-hwad-written-differences]");
  var howWeAreDifferentTitleFlagElement = howWeAreDifferentSection.querySelector("[data-hwad-title-flag]");
  var howWeAreDifferentHighlightsContainer = howWeAreDifferentSection.querySelector("[data-hwad-highlights-container]");
  var howWeAreDifferentCharacterCircles = howWeAreDifferentSection.querySelector("[data-hwad-character-circles]");
  var howWeAreDifferentLottiePlayer = howWeAreDifferentSection.querySelector("[data-hwad-lottie-player]");

  var howWeAreDifferentLottieFileUrl = window.innerWidth > 1300 ? 
    howWeAreDifferentLottiePlayer.dataset.src : howWeAreDifferentLottiePlayer.dataset.srcMobile;

  // parallax or vibrate effect
  const platform = determinePlatform();
  if (platform === 'mac' || platform === 'ios') {
    // vibrate effect for the elements in the section on mac and IOS devices (instead of parallax)
    
  } else {
    // parallax
    const howWeAreDifferentBgParallax = new ElementParallax(howWeAreDifferentSection, howWeAreDifferentBgElement, 
      { scale: 1, x: -50, y: -50 }, 0, { scale: 1.05, x: -50, y: -50 }, 1.5);
    const centeredContentElementsParallax = [howWeAreDifferentDrawnDifferencesElement, howWeAreDifferentWrittenDifferencesElement, 
      howWeAreDifferentTitleFlagElement, howWeAreDifferentHighlightsContainer].map(element => {
      return new ElementParallax(howWeAreDifferentSection, element, { x: -50, y: -30 }, 0, { x: -50, y: -66 }, 2);
    });
    let howWeAreDifferentLottieContainerParallax, howWeAreDifferentTitleFlagElementParallax;
    if (window.innerWidth > 1300) {
      howWeAreDifferentTitleFlagElementParallax = new ElementParallax(howWeAreDifferentSection, howWeAreDifferentTitleFlagElement, { x: -50, y: -30 }, 0, { x: -50, y: -66 }, 2);
      howWeAreDifferentLottieContainerParallax = new ElementParallax(howWeAreDifferentSection, howWeAreDifferentLottiePlayer, 
        { x: -50, y: 15 }, 0, { x: -50, y: -12 }, 2);
    } else {
      howWeAreDifferentTitleFlagElementParallax = new ElementParallax(howWeAreDifferentSection, howWeAreDifferentTitleFlagElement, { x: -50, y: -18 }, 0, { x: -50, y: -80 }, 2);
      howWeAreDifferentLottieContainerParallax = new ElementParallax(howWeAreDifferentSection, howWeAreDifferentLottiePlayer, 
        { x: -50, y: 8 }, 0, { x: -50, y: -6 }, 2);
    }
    const howWeAreDifferentCharacterCirclesParallax = new ElementParallax(howWeAreDifferentSection, howWeAreDifferentCharacterCircles,
      { y: 10 }, 0.4, { y: -6 }, 1.5);

    window.addEventListener("load", handleParallax);
    window.addEventListener("scroll", handleParallax);

    function handleParallax() {
      const currentScroll = document.documentElement.scrollTop;

      howWeAreDifferentBgParallax.apply(currentScroll);
      centeredContentElementsParallax.forEach(element => element.apply(currentScroll));
      howWeAreDifferentLottieContainerParallax.apply(currentScroll);
      howWeAreDifferentCharacterCirclesParallax.apply(currentScroll);
      howWeAreDifferentTitleFlagElementParallax.apply(currentScroll);
    }
  }

  // lottie
  var hwadSectionWasAlreadyInViewport = false;

  function reloadPlayer(player) {
    player.load(howWeAreDifferentLottieFileUrl);
  
    player.addEventListener('ready', () => {
      player.play();
      player.setSpeed(2);
    });
  }

  function addHwadObserver() {
    const hwadObserver = new IntersectionObserver(entries => {
      const sectionEntry = entries[0];

      if (sectionEntry.isIntersecting && hwadSectionWasAlreadyInViewport === false) {
        hwadSectionWasAlreadyInViewport = true;
        reloadPlayer(howWeAreDifferentLottiePlayer);
      } else {
        hwadSectionWasAlreadyInViewport = false;
      }
    }, {
      threshold: 0.4
    });
    hwadObserver.observe(howWeAreDifferentSection);
  }

  window.addEventListener("load", () => {
    howWeAreDifferentLottiePlayer.load(howWeAreDifferentLottieFileUrl);

    howWeAreDifferentLottiePlayer.addEventListener('ready', () => {
      addHwadObserver();
    }, { once: true });
  });
}